import { palette } from '../../styles/theme';

export default {
    pending: {
        id: 1,
        text: 'Pendiente',
        type: 'danger'
    },
    active: {
        id: 2,
        text: 'Activo',
        type: 'success'
    },
    recovery: {
        id: 3,
        text: 'Recupero',
        type: 'info'
    },
    blocked: {
        id: 4,
        text: 'Bloqueado',
        type: 'error'
    },
    inactive: {
        id: 5,
        text: 'Inactivo',
        type: 'dark'
    },
    1: {
        id: 6,
        text: 'Información',
        type: 'info'
    },
    failure: {
        id: 7,
        text: 'Rechazado',
        type: 'danger'
    },
    success: {
        id: 8,
        text: 'Exitoso',
        type: 'success'
    },
    undefined: {
        id: 9,
        text: 'Información',
        type: 'info'
    },
    null: {
        id: 10,
        text: 'Información',
        type: 'info'
    },
    revision: {
        id: 11,
        text: 'En Revision',
        type: 'warning'
    },
};

export const colorStatus = {
    active: {
        color: palette.success[800],
        background: palette.success[200]
    },
    recovery: {
        color: palette.tertiary[800],
        background: palette.tertiary[200]
    },
    inactive: {
        color: palette.disabled[800],
        background: palette.disabled[200]
    },
    blocked: {
        color: palette.error[800],
        background: palette.error[200],
    }
};
